// Field help for the customer page's Activity → Prompt logs sub-tab (API-016, REQ-244). Keys are the ids passed to
// <Field help="…"> and the Body column; every rendered label must have one
// (tests/unit/help.test.ts).
import type { HelpTopic } from "../topic";

export const PROMPT_LOGS_TOPICS = {
  "promptLogs.user": {
    title: "User",
    body: "Only the prompts of this user. Type part of their name, email or external id and pick them from the list, then press Filter. Leave it empty, or pick All users, for every user. The list holds the customer's first 500 users.",
    example: "Type “dana” and pick Dana Lee (dana@example.com) to see only Dana's prompts.",
    article: "users-teams-and-sign-in",
    section: "users-and-teams",
  },
  "promptLogs.model": {
    title: "Model",
    body: "Only prompts sent to this Bedrock model id, matched exactly. Leave it empty for every model.",
    example: "anthropic.claude-3-5-sonnet-20241022-v2:0 shows only that model's prompts.",
    article: "adding-a-customer",
    section: "settings",
  },
  "promptLogs.range": {
    title: "From and To",
    body: "The UTC days to list, both inclusive. With neither set the last 30 days are shown; with only From, everything since then.",
    example: "From 2026-09-01 to 2026-09-30 lists September's prompts.",
    article: "adding-a-customer",
    section: "settings",
  },
  "promptLogs.bodyStatus": {
    title: "Body",
    body: "What became of the prompt body. Stored (or stored, truncated) can be opened; discarded by policy means logging was off when it arrived; too large means it exceeded the size limit; erased means the user's data was erased. Every list and every read is recorded in the audit log.",
    example: "A 70 MB prompt shows Too large: its metadata is kept, the body was never stored.",
    article: "adding-a-customer",
    section: "settings",
  },
} satisfies Record<string, HelpTopic>;
